import { FC } from "react";
import Stack from "@mui/material/Stack";
import { Chip, Divider, Typography } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { FiltersDisabledView } from "@/components/pages/common/filters/filters-disabled-view/FiltersDisabledView";
import { TooltipWithContent } from "@/components/common/TooltipWithContent";
import { ResourceFilters } from "@/services/cloudchipr.api";

interface AutomationsFoundResourcesGridToolbarFiltersProps {
  filter: ResourceFilters;
}

export const AutomationsFoundResourcesGridToolbarFilters: FC<
  AutomationsFoundResourcesGridToolbarFiltersProps
> = ({ filter }) => {
  if (!filter) {
    return null;
  }

  return (
    <TooltipWithContent
      componentsProps={tooltipComponentProps}
      placement="bottom-start"
      arrow={false}
      title={
        <Stack>
          <Stack p={1}>
            <Typography variant="body2">Instances Filters</Typography>
          </Stack>
          <Divider />
          <Stack p={1}>
            <FiltersDisabledView filter={filter} />
          </Stack>
        </Stack>
      }
    >
      <Chip
        variant="filled"
        size="small"
        sx={{ mr: 2 }}
        icon={<FilterAltOutlinedIcon />}
        label={
          <Typography variant="caption">
            Filters: ({filter.filter_items.length})
          </Typography>
        }
      />
    </TooltipWithContent>
  );
};

const tooltipComponentProps = {
  tooltip: {
    sx: {
      maxWidth: "40dvw",
      width: "max-content",
    },
  },
};
